import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../hooks/useSubmitData";
import { useSetMenu } from "../../../hooks/useSetMenu";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import * as yup from "yup";
import FormSelect from '../../Generic/FormSelect';

const Add = () => {

    const { mainStore } = useStore();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    useSetMenu(mainStore.SubcategoryMenuType, mainStore.SubcategoryMenuNo);
    const onError = (errors, e) =>
        enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

    const schema = yup.object({
        name: yup
            .string()
            .required(t('requiredField'))
            .max(250, t('maxLength', { max: 250 })),
        categoryId: yup.string().required(t("selectRequired")),
    });

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const sendData = useSubmitData(axiosPrivate, "/Subcategories", "/Subcategory/List");
    const onSubmit = data => sendData(data);
    const onCancel = () => navigate(-1);

    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, [t]);

    //#region Category Select
    const [categories, setCategories] = useState([]);
    async function loadData() {
        try {
            const categoriesResponse = await axiosPrivate.get("/Categories/SelectOptions");
            setCategories(categoriesResponse.data);
        } catch (err) {
            enqueueSnackbar(t("loadDataError"), { variant: "error" });
        }
    }
    const handleCategoryChange = selectedOption => {
        setValue("categoryId", selectedOption.value, { shouldValidate: true });
    };
    //#endregion

    return (
        <FormLayout title={t("subcategoryCreateTitle")} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
            <FormSelect label="category" name="categoryId" register={register} errors={errors} options={categories} onChange={handleCategoryChange} />
            <FormInput label="subcategory" name="name" register={register} errors={errors} />
        </FormLayout>
    );
};

export default Add;